import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { UserInfo } from "src/components/UserInfo";
import { ButtonDownload } from "src/components/ButtonDownload";
import { ButtonVariants } from "src/components/Button/types";
import { getImageUrl } from "src/utils/getImageUrl";
import { IUser } from "src/@types/users";
import { approvedDealTrns } from "../trns";

export const DealInfo: FC<IUser> = ({ ...user }) => {
  const { t } = useTranslation();

  const handleDownload = () => { };

  return (
    <div className="flex flex-1 flex-col basis-1/2 gap-5 px-3 py-5 lg:px-5 xl:p-10 bg-purple-lighter rounded-20">
      <div className="flex items-center gap-5 bg-gray-light px-5 py-2 text-purple-base border border-black-base border-opacity-20 rounded-20">
        <div>
          <img
            className="max-w-11 rounded-full"
            src={getImageUrl(user.host.avatarUrl)}
            alt={user.host.company_name}
          />
        </div>

        <div className="flex gap-2 text-lg">
          <p className="font-semibold">{user.host.role}:</p>
          <p>{user.host.first_name}</p>
        </div>
      </div>

      <UserInfo
        className="bg-gray-light"
        userInfo={user}
      />

      <ButtonDownload variant={ButtonVariants.GRAY} onClick={handleDownload}>
        {t(approvedDealTrns.downloadButton)}
      </ButtonDownload>
    </div>
  );
};
